'use strict';

var clearErrorOnField = require('./clearErrorOnField');
var performMailCheckJs = require('./performMailCheck');
var showErrorForField = require('./showErrorForField');
var validateEmailAddress = require('../helpers/validateEmail');

function performFieldValidation ($elements) {
  var isValid = true;

  $elements.each(function () {
    var valTmp;
    var $this = $(this);

    if ($this.hasClass('required')) {
      if ($this.val() === '') {
        isValid = false;
        return showErrorForField($this);
      }
    }

    // remove error on every field
    clearErrorOnField($this);

    if ($this.hasClass('mailcheck')) {
      valTmp = $this.val();
      valTmp = $.trim(valTmp);

      $this.val(valTmp);

      // validate emails fields
      if (valTmp === '') {
        isValid = false;
        return showErrorForField($this);
      } else if (!validateEmailAddress($this)) {
        isValid = false;
        return showErrorForField($this, 'mail');
      } else {
        return performMailCheckJs($this);
      }
    } else if ($this.hasClass('password')) {
      // validate passwords field
      if ($this.val() === '') {
        showErrorForField($this);
        isValid = false;
        return isValid;
      }
    }
  });

  // return is valid or not
  return isValid;
}

module.exports = performFieldValidation;
